import { defineComponent as _defineComponent } from 'vue'
import WalletTransactionsListing from './WalletTransactionsListing.vue';
import WithdrawFromWalletModal from './WithdrawFromWalletModal.vue';
import DownloadStatementModal from 'ah-wallets/src/components/transactions/DownloadStatementModal.vue';
import {
  walletScheduledTransactionsTableFields,
  walletTransactionsTableFields,
} from 'ah-trades/src/models/transactionsTableFields';
import FeesInfoBlock from 'ah-trades/src/components/fees/FeesInfoBlock.vue';
import { AuthorityType, TransactionType, ScheduleState, Client } from 'ah-api-gateways';
import WalletInfoHeaderMobile from './WalletInfoHeaderMobile.vue';
import WalletInfoTitle from './WalletInfoTitle.vue';
import QueryStringTabs from 'ah-common-lib/src/common/components/QueryStringTabs.vue';
import { computed, inject, onMounted, reactive, ref, watch } from 'vue';
import { ON_BEHALF_OF_CLIENT_INJECT_KEY } from 'ah-common-lib/src/onBehalfOf/constants';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { useAhWalletsState } from '..';
import { useRoute } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'WalletInfo',
  props: {
    walletId: null,
    readonly: { type: [Boolean, String], default: false }
  },
  emits: ["back-to-list", "wallet-changed"],
  setup(__props: any, { expose, emit }: { emit: ({
  /**
   * when the back button is pressed
   */
  (e: 'back-to-list', value: void): void;
  /**
   * when a withdraw or a payment is made
   */
  (e: 'wallet-changed', value: void): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { walletId: string, readonly: boolean | string };

const walletState = useAhWalletsState();

const requestManager = useRequestManager({
  exposeToParent: ['loadWallet', 'waitForChange'],
  onRetryFromParentManager: (k: string) => {
    if (k === 'loadWallet') {
      loadWallet();
    }
  },
});



const state = reactive<{
  onBehalfOfClient: Client | null;
  tabIndex: number;
}>({
  onBehalfOfClient: inject(ON_BEHALF_OF_CLIENT_INJECT_KEY, null),
  tabIndex: 0,
});



const scheduledTransactions = ref<InstanceType<typeof WalletTransactionsListing> | null>(null);

const pastTransactions = ref<InstanceType<typeof WalletTransactionsListing> | null>(null);

const tabsContainer = ref<InstanceType<typeof QueryStringTabs> | undefined>(undefined);

const route = useRoute();

onMounted(() => {
  if (route.query.fees !== undefined) {
    setTimeout(() => (state.tabIndex = 2));
  }
});

const canSeeFees = computed(() => {
  return walletState.store
    .useAuthStore()
    .hasAuthorities([AuthorityType.VIEW_WALLET_FEES, AuthorityType.VIEW_FEES], true);
});

const canSeeTransactions = computed(() => {
  return walletState.store.useAuthStore().hasAuthorities(AuthorityType.VIEW_TRANSACTIONS);
});

const wallet = computed(() => walletState.store.useWalletsStore().getWalletById(props.walletId));

const isChargesWallet = computed(() => wallet.value?.currency === 'GBP');

const canMakeOwnPayments = computed(
  () => !state.onBehalfOfClient && walletState.store.useAuthStore().hasAuthorities(AuthorityType.MAKE_PAYMENTS)
);

const canMakeOBOPayments = computed(() =>
  state.onBehalfOfClient?.permissions?.includes(AuthorityType.PAY_ON_BEHALF_OF)
);

/**
 * Withdraw is allowed ONLY in non-OBO settings (readonly is ignored if onBehalfOfClient is set)
 */
const withdrawAllowed = computed(() => canMakeOwnPayments.value && !state.onBehalfOfClient && !isReadonly.value);

const sendMoneyAllowed = computed(() => (canMakeOBOPayments.value || canMakeOwnPayments.value) && !isReadonly.value);

const isReadonly = computed(() => props.readonly !== false);

/**
 * Historical Transactions filter - shows all types except PENDING_BALANCE
 */
const historicalTransactionFilters = {
  type: [
    TransactionType.DEPOSIT,
    TransactionType.WITHDRAW,
    TransactionType.WALLETS_MOVEMENT,
    TransactionType.WITHDRAW_COLLATERAL,
    TransactionType.POST_COLLATERAL,
    TransactionType.COLLECT_COLLATERAL,
    TransactionType.ROLLBACK,
    TransactionType.ADJUSTMENT,
  ],
};

const scheduledTransactionFilters = {
  scheduleState: [
    ScheduleState.PENDING_CONFIRMATION,
    ScheduleState.READY,
    ScheduleState.SUBMITTED,
    ScheduleState.FAILED_EXTERNALLY,
    ScheduleState.FAILED_EXECUTION,
  ],
};

function loadWallet() {
  requestManager.manager.newPromise(
    'loadWallet',
    walletState.store.useWalletsStore().loadWallet({ id: props.walletId, force: true })
  );
}

watch(() => props.walletId, loadWallet);

function onTradeCompleted() {
  refresh();
}

function goBack() {
  emit('back-to-list');
}

function refresh() {
  scheduledTransactions.value?.loadData();
  pastTransactions.value?.loadData();
  emit('wallet-changed');
}

expose({ refresh });

return { __sfc: true,walletState, requestManager, props, state, emit, scheduledTransactions, pastTransactions, tabsContainer, route, canSeeFees, canSeeTransactions, wallet, isChargesWallet, canMakeOwnPayments, canMakeOBOPayments, withdrawAllowed, sendMoneyAllowed, isReadonly, historicalTransactionFilters, scheduledTransactionFilters, loadWallet, onTradeCompleted, goBack, refresh, WalletTransactionsListing, WithdrawFromWalletModal, DownloadStatementModal, walletScheduledTransactionsTableFields, walletTransactionsTableFields, FeesInfoBlock, WalletInfoHeaderMobile, WalletInfoTitle, QueryStringTabs }
}

})